import axios from 'axios';
import Auth from '../lib/auth';
import utilsLib from './utils.lib';
import {addNotification} from "./notifications";

export const GET_WAREHOUSES_REQUEST = 'GET_WAREHOUSES_REQUEST';
export const GET_WAREHOUSES_SUCCESS = 'GET_WAREHOUSES_SUCCESS';
export const GET_WAREHOUSES_ERROR = 'GET_WAREHOUSES_ERROR';

export const GET_WAREHOUSE_REQUEST = 'GET_WAREHOUSE_REQUEST';
export const GET_WAREHOUSE_SUCCESS = 'GET_WAREHOUSE_SUCCESS';
export const GET_WAREHOUSE_ERROR = 'GET_WAREHOUSE_ERROR';

export const CREATE_WAREHOUSE_REQUEST = 'CREATE_WAREHOUSE_REQUEST';
export const CREATE_WAREHOUSE_SUCCESS = 'CREATE_WAREHOUSE_SUCCESS';
export const CREATE_WAREHOUSE_ERROR = 'CREATE_WAREHOUSE_ERROR';

export const UPDATE_WAREHOUSE_REQUEST = 'UPDATE_WAREHOUSE_REQUEST';
export const UPDATE_WAREHOUSE_SUCCESS = 'UPDATE_WAREHOUSE_SUCCESS';
export const UPDATE_WAREHOUSE_ERROR = 'UPDATE_WAREHOUSE_ERROR';

export const CHANGE_STATUS_WAREHOUSE_REQUEST = 'CHANGE_STATUS_WAREHOUSE_REQUEST';
export const CHANGE_STATUS_WAREHOUSE_SUCCESS = 'CHANGE_STATUS_WAREHOUSE_SUCCESS';
export const CHANGE_STATUS_WAREHOUSE_ERROR = 'CHANGE_STATUS_WAREHOUSE_ERROR';

export const DELETE_WAREHOUSE_ERROR = 'DELETE_WAREHOUSE_ERROR';
export const DELETE_WAREHOUSE_REQUEST = 'DELETE_WAREHOUSE_REQUEST';
export const DELETE_WAREHOUSE_SUCCESS = 'DELETE_WAREHOUSE_SUCCESS';

export const CLEAN_WAREHOUSES = 'CLEAN_WAREHOUSES';

// Get warehouses
export function getWarehouses(query) {
    return async (dispatch) => {
        try {
            dispatch(getWarehousesRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/warehouses/query', query, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getWarehousesSuccess, getWarehousesError));
        } catch (err) {
            dispatch(utilsLib.response(err, getWarehousesError));
        }
    };
}

function getWarehousesRequest() {
    return {
        type: GET_WAREHOUSES_REQUEST,
        isFetching: true
    };
}

function getWarehousesSuccess (payload) {
    return {
        type: GET_WAREHOUSES_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}

function getWarehousesError(errorMessage) {
    return {
        type: GET_WAREHOUSES_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Get warehouse
export function getWarehouse(warehouseId) {

    return async (dispatch) => {
        try {
            dispatch(getWarehouseRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.get(`/api/warehouses/${warehouseId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getWarehouseSuccess, getWarehouseError));
        } catch (err) {
            dispatch(utilsLib.response(err, getWarehouseError));
        }
    };
}

function getWarehouseRequest() {
    return {
        type: GET_WAREHOUSE_REQUEST,
        isFetching: true
    };
}

function getWarehouseSuccess (payload) {
    return {
        type: GET_WAREHOUSE_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}

function getWarehouseError(errorMessage) {
    return {
        type: GET_WAREHOUSE_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Create warehouse
export function createWarehouse(warehouse) {
    return async (dispatch) => {
        try {
            dispatch(createWarehouseRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/warehouses', warehouse, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, createWarehouseSuccess, createWarehouseError));
        } catch (err) {
            dispatch(utilsLib.response(err, createWarehouseError));
        }
    };
}

function createWarehouseRequest() {
    return {
        type: CREATE_WAREHOUSE_REQUEST,
        isFetching: true
    };
}

function createWarehouseSuccess (payload) {
    return dispatch => {
        // Create notification for create warehouse success
        dispatch(addNotification({
            message: 'Almacén creado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: CREATE_WAREHOUSE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}

function createWarehouseError(errorMessage) {
    return dispatch => {
        // Create notification for create warehouse error
        dispatch(addNotification({
            message: 'Error al crear el almacén',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CREATE_WAREHOUSE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Update warehouse
export function updateWarehouse(warehouseId, warehouse = {}) {
    return async (dispatch) => {
        try {
            dispatch(updateWarehouseRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/warehouses/${warehouseId}`, warehouse, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, updateWarehouseSuccess, updateWarehouseError));
        } catch (err) {
            dispatch(utilsLib.response(err, updateWarehouseError));
        }
    };
}

function updateWarehouseRequest() {
    return {
        type: UPDATE_WAREHOUSE_REQUEST,
        isFetching: true
    };
}

function updateWarehouseSuccess (payload) {
    return dispatch => {
        // Create notification for update warehouse success
        dispatch(addNotification({
            message: 'Almacén actualizado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: UPDATE_WAREHOUSE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}

function updateWarehouseError(errorMessage) {
    return dispatch => {
        // Create notification for update warehouse error
        dispatch(addNotification({
            message: 'Error al actualizar el almacén',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPDATE_WAREHOUSE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Change warehouse status
export function changeWarehouseStatus(warehouseId, status) {
    return async (dispatch) => {
        try {
            dispatch(changeWarehouseStatusRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/warehouses/${warehouseId}/status`, { status }, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, changeWarehouseStatusSuccess, changeWarehouseStatusError));
        } catch (err) {
            dispatch(utilsLib.response(err, changeWarehouseStatusError));
        }
    };
}

function changeWarehouseStatusRequest() {
    return {
        type: CHANGE_STATUS_WAREHOUSE_REQUEST,
        isFetching: true
    };
}

function changeWarehouseStatusSuccess (payload) {
    return dispatch => {
        // Create notification for update status success
        dispatch(addNotification({
            message: 'Estado actualizado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: CHANGE_STATUS_WAREHOUSE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}

function changeWarehouseStatusError(errorMessage) {
    return dispatch => {
        // Create notification for update status error
        dispatch(addNotification({
            message: 'Error al actualizar el estado',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CHANGE_STATUS_WAREHOUSE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Get customer
export function deleteWarehouse(warehouseId) {

    return async (dispatch) => {
        try {
            dispatch(deleteWarehouseRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.delete(`/api/warehouses/${warehouseId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deleteWarehouseSuccess, deleteWarehouseError));
        } catch (err) {
            dispatch(utilsLib.response(err, deleteWarehouseError));
        }
    };
}

function deleteWarehouseRequest() {
    return {
        type: DELETE_WAREHOUSE_REQUEST,
        isFetching: true
    };
}

function deleteWarehouseSuccess (payload) {
    return dispatch => {
        // Create notification for delete customer success
        dispatch(addNotification({
            message: 'Almacén eliminado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: DELETE_WAREHOUSE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}

function deleteWarehouseError(errorMessage) {
    return dispatch => {
        // Create notification for delete customer error
        dispatch(addNotification({
            message: 'Error al eliminar el almacén',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: DELETE_WAREHOUSE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Clean warehouses reducer
export function cleanWarehouses() {
    return {
        type: 'CLEAN_WAREHOUSES',
        isFetching: false,
        error: false,
        payload: []
    }
}



// WEBPACK FOOTER //
// ./src/actions/warehouses.js